import * as yup from 'yup';

export const filterSchema = yup.object({
   marca: yup.string(),
   modelo: yup.string(),
   aitvo: yup.string(),
});